import { useState } from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import AboutUs from "@/components/AboutUs";
import CaseStudies from "@/components/CaseStudies";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import SEO from "@/components/SEO";
import LoadingScreen from "@/components/LoadingScreen";

const Index = () => {
  const [isLoading, setIsLoading] = useState(() => {
    return !localStorage.getItem("hasVisitedHome");
  });

  const handleLoadingComplete = () => {
    localStorage.setItem("hasVisitedHome", "true");
    setIsLoading(false);
  };

  if (isLoading) {
    return <LoadingScreen onComplete={handleLoadingComplete} />;
  }

  return (
    <main className="min-h-screen bg-gradient-to-b from-primary/[0.03] via-background to-primary/[0.02] text-foreground relative">
      {/* Static subtle glow - no animation for power saving */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden hidden md:block">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/[0.03] rounded-full blur-[100px]" />
      </div>
      <SEO 
        title="Home"
        description="DePIN Land - Empowering African communities through decentralized physical infrastructure. Join Africa's premier DePIN community."
        url="/"
      />
      <Navigation />
      <Hero />
      <AboutUs />
      <CaseStudies />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
      <ScrollToTop />
    </main>
  );
};

export default Index;
